import React from 'react'
import EstimatedPriceEntryContent from '../components/EstimatedPriceEntryContent'

const EstimatedPriceEntry = () => {
  return (
    <div className="brand-fonts bg-white">
      <EstimatedPriceEntryContent />
    </div>
  )
}

export default EstimatedPriceEntry
